

import { ApiService } from '../services/api'
export const minimum_entry_requirements = {
	namespaced: true,
	state: {
		currentRecord: null,
		records: [],
		requestError: null,
	},
	getters: {
		records(state) {
			return state.records
		},
		currentRecord(state) {
			return state.currentRecord
		},
	},
	mutations: {
		setRecords(state, records) {
			state.records = records
		},
		setCurrentRecord(state, record) {
			state.currentRecord = record;
		},
		mergeRecords(state, records) {
			state.records = state.records.concat(records);
		},
		setError(state, errors) {
			state.requestError = error
		},
	},
	actions: {
		fetchRecords: ({ commit }, payload) => {
			return new Promise((resolve, reject) => {
				let url = payload.url;
				let merge = payload.merge;
				ApiService.get(url).then(resp => {
					let data = resp.data;
					if (data.records) {
						let records = data.records;
						if (merge){
							commit("mergeRecords", records);
						}
						else{
							commit("setRecords", records);
						}
						resolve(data);
					}
					else {
						reject("invalid json data");
					}
				}).catch(err => {
					reject(err)
				})
			})
		},
		fetchRecord: ({ commit }, url) => {
			return new Promise((resolve, reject) => {
				ApiService.get(url).then(resp => {
					resolve(resp)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
	}
}
